<template>
  <div id="app"
       style="width: 100vw;height:100vh;">
    <router-view></router-view>
  </div>
</template>

<script>
import checkArticle from './components/checkArticle.vue'

export default {
  name: 'App',
  components: {
    checkArticle
  }
}
</script>

<style >
* {
  margin: 0;
  padding: 0;
}
</style>